export default __webpack_public_path__ + "static/media/main_img_3.049a25e6.jpg";